import { Map, List } from "immutable";

import {
  ADMIN_PARTNER_CLASS_LIST_REQUEST,
  ADMIN_PARTNER_CLASS_LIST_SUCCESS,
  ADMIN_PARTNER_CLASS_LIST_FAILURE,
  ADMIN_PARTNER_CLASS_READ_REQUEST,
  ADMIN_PARTNER_CLASS_READ_SUCCESS,
  ADMIN_PARTNER_CLASS_READ_FAILURE,
  ADMIN_PARTNER_CLASS_UPDATE_REQUEST,
  ADMIN_PARTNER_CLASS_UPDATE_SUCCESS,
  ADMIN_PARTNER_CLASS_UPDATE_FAILURE,
  ADMIN_PARTNER_CLASS_CREATE_REQUEST,
  ADMIN_PARTNER_CLASS_CREATE_SUCCESS,
  ADMIN_PARTNER_CLASS_CREATE_FAILURE,
  ADMIN_PARTNER_CLASS_DELETE_REQUEST,
  ADMIN_PARTNER_CLASS_DELETE_SUCCESS,
  ADMIN_PARTNER_CLASS_DELETE_FAILURE,
  ADMIN_PARTNER_CLASS_FORM_DESTROY,
  ADMIN_PARTNER_CLASS_CSV_DOWNLOAD_REQUEST,
  ADMIN_PARTNER_CLASS_CSV_DOWNLOAD_SUCCESS,
  ADMIN_PARTNER_CLASS_CSV_DOWNLOAD_FAILURE,
  ADMIN_PARTNER_CLASS_PARTNERSHIP_LIST_REQUEST,
  ADMIN_PARTNER_CLASS_PARTNERSHIP_LIST_SUCCESS,
  ADMIN_PARTNER_CLASS_PARTNERSHIP_LIST_FAILURE,
} from "./actions";
import Logger from "../../../lib/Logger";

export default function adminPartnerClasses(
  state = Map({
    isLoading: false,
    areCareGuidePartnerTagsLoading: false,
    isCSVDownloading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    "debug",
    `[adminPartnerClasses.reducers] adminPartnerClasses(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case ADMIN_PARTNER_CLASS_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case ADMIN_PARTNER_CLASS_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ["pages", action.order, action.limit, action.page],
          List(action.result)
        );

    case ADMIN_PARTNER_CLASS_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case ADMIN_PARTNER_CLASS_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case ADMIN_PARTNER_CLASS_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case ADMIN_PARTNER_CLASS_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case ADMIN_PARTNER_CLASS_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case ADMIN_PARTNER_CLASS_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case ADMIN_PARTNER_CLASS_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(["form", "errors"], action.error);

    case ADMIN_PARTNER_CLASS_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case ADMIN_PARTNER_CLASS_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case ADMIN_PARTNER_CLASS_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(["form", "errors"], action.error);

    case ADMIN_PARTNER_CLASS_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case ADMIN_PARTNER_CLASS_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case ADMIN_PARTNER_CLASS_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case ADMIN_PARTNER_CLASS_FORM_DESTROY:
      return state
        .mergeDeep({
          form: null,
        })
        .set("form", action.form);

    case ADMIN_PARTNER_CLASS_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true,
      });

    case ADMIN_PARTNER_CLASS_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case ADMIN_PARTNER_CLASS_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case ADMIN_PARTNER_CLASS_PARTNERSHIP_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case ADMIN_PARTNER_CLASS_PARTNERSHIP_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          adminPartnerClasses: {
            [action.partnershipId]: {
              total: action.total,
            },
          },
          lastUpdated: action.receivedAt,
        })
        .setIn(
          [
            "adminPartnerClasses",
            action.partnershipId,
          ],
          List(action.result)
        );

    case ADMIN_PARTNER_CLASS_PARTNERSHIP_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });


    default:
      return state;
  }
}

Logger.log("silly", `adminPartnerClasses.reducers loaded.`);
